import * as React from 'react';
import b_ from 'b_';

import './index.scss';

export interface Option<T = any> {
  value?: T;
  title: React.ReactNode;
  titleAsActual?: string | React.ReactElement;
}

interface Props {
  options: Option[];
  actualIndex: number;
  onClick: (value: any) => void;
}

const b = b_.with('stocks-filter-options');

const Options: React.SFC<Props> = ({ actualIndex, options, onClick }) => (
  <div className={b()}>
    <div className={b('content')}>
      {options.map(({ title, value }, i) => (
        <div
          key={i}
          className={b('item', { active: actualIndex === i })}
          onClick={() => onClick(value)}
        >
          {title}
        </div>
      ))}
    </div>
  </div>
);

export default Options;
